<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/schoolClass/listAll"
            create-url="/schoolClass/save"
            delete-url="/schoolClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            :custom-edit-item="true"
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="true"
            :acceptView="false"
            :accept-edit="true"
            :acceptCreate2=true
            :accept-create=false
            :acceptExport="0"
            @showReport="showReport"
            @viewItem=""
        >
        </c-search-form>
        <school-create-form
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        ></school-create-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import SchoolCreateForm from "@/views/admin/school_class/SchoolClassCreate";

export default {
  name: "school-class",
  components: {SchoolCreateForm, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách các lớp",
      formCreateName: "Thêm mới lớp",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'className',
          text: 'Tên lớp',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: "ageId",
          text: "Độ tuổi",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "ageId",
          items: [],
          itemText: "categoryName",
          itemValue: "categoryId",
        },
        {
          value: 'classAccount',
          text: 'Tên tài khoản',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: 'numberStudent',
          text: 'Sĩ số',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: "levelStartId",
          text: "Level bắt đầu",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "levelStartId",
          items: [],
          itemText: "categoryName",
          itemValue: "categoryId",
        },
        {
          value: 'custom_action_list',
          width: "5%",
          text: 'Báo cáo kết quả tuần trước',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "assessment",
              event: "showReport",
              color: "primary"
            },
          ],
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    const domain = window.location.hostname;
    const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
    this.hiddenFields.product = product;

    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_AGE&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "ageId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_LEVEL_START&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelStartId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );

  },

  methods: {
    showReport(item) {
      window.open(item.reportLink, "_blank");
    },
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },

  destroyed() {
  },
};
</script>
